import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Store, Map as MapIcon, LayoutDashboard } from "lucide-react";
import { useApp } from "../context/AppContext";
import { useAuth } from "../context/AuthContext";

/* Phones only (<768px). Fixed, glass + gold active state, safe-area aware. Hidden inside admin. */
export default function MobileTabBar() {
  const { t } = useApp();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  useEffect(() => { document.body.classList.toggle("has-tabbar", !isAdmin); return () => document.body.classList.remove("has-tabbar"); }, [isAdmin]);
  if (isAdmin) return null;
  const dashActive = /^\/(dashboard|provenance\/dashboard|trader\/dashboard|souq\/dashboard|auth)/.test(pathname);
  const tabs = [
    { id: "home", to: "/", Icon: Home, label: t("nav.home"), active: pathname === "/" },
    { id: "souq", to: "/souq", Icon: Store, label: t("nav.souq"), active: pathname.startsWith("/souq") && !pathname.startsWith("/souq/dashboard") },
    { id: "map", to: "/map", Icon: MapIcon, label: t("nav.map"), active: pathname.startsWith("/map") },
    { id: "dashboard", to: user ? "/dashboard" : "/auth", Icon: LayoutDashboard, label: t("tab.dashboard"), active: dashActive },
  ];
  return (
    <nav className="mobile-tabbar" data-testid="mobile-tabbar" aria-label="Primary">
      {tabs.map(({ id, to, Icon, label, active }) => (
        <Link key={id} to={to} className={`mobile-tab ${active ? "active" : ""}`} data-testid={`tab-${id}`} aria-current={active ? "page" : undefined}>
          <Icon size={20} />
          <span>{label}</span>
        </Link>
      ))}
    </nav>
  );
}
